export const LS_FIELD_USER = '_BZ_u_';
export const LS_FIELD_JWT = '_BZ_ss_'; 